import styled from 'styled-components';
import { rgba } from 'polished';
import { COLOR_PURPLE, COLOR_WHITE, COLOR_ORANGE, COLOR_BLUE } from '../../../assets/styles/colors';
import { BP_TABLET_MAX, BP_MOBILE_MAX } from '../../../assets/styles/breakpoints';

export default styled.nav`
  width: 100%;
  position: relative;
  display: block;
  margin: 0 auto;
  background: ${COLOR_PURPLE};
  height: auto;

  @media (max-width: ${BP_MOBILE_MAX}px) {
    height: 124px;
    display: flex;
    align-items: flex-end;
    padding-bottom: 16px;
  }
`;

export const InnerMenuWrapSC = styled.div`
  height: 80px;
  max-width: 1440px;
  width: 100%;
  padding: 0 33px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0 auto;

  .menu-wrap {
    width: 100%;
    padding-left: 64px;
    padding-right: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .menu-wrap,
  .user-wrap {
    a {
      color: ${COLOR_WHITE};
      opacity: 0.8;
      font-size: 18px;
      font-weight: normal;
      margin-right: 32px;
      &:last-child {
        margin-right: 0px;
      }
      &:hover {
        text-decoration: none;
        color: ${COLOR_WHITE};
        opacity: 1;
      }
      &.active {
        color: ${COLOR_WHITE};
        opacity: 1;
        font-weight: 600;
      }
    }
    .more-menu {
      display: inline-block;
      position: relative;
      top: -2px;
      button {
        background: none;
        border: none;
        padding: 10px 0px 10px 0;
        margin: 0;
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: bold;
        color: ${COLOR_WHITE};
        margin-top: 3px;
      }
      .hidden-menu {
        padding: 32px;
        border-radius: 12px;
        border-top-left-radius: 0px;
        border: solid 1px #403f4f;
        background-color: #2b2a3c;
        display: none;
        flex-direction: column;
        height: auto;
        width: auto;
        min-width: 200px;
        position: absolute;
        z-index: 999;
        left: 0px;
        top: 22px;
        a {
          margin: 5px 0;
        }
        &.active {
          display: flex;
        }
      }
    }
  }
  .logo-wrap {
    width:100%;
    max-width: 139px;
    padding-top: 10px;

    a {
      display: block;
      opacity: 1;
    }
    svg {
      display: block;
    }
  }

  .user-wrap {
    display: flex;
    align-items: center;
    position: relative;
    justify-content: flex-end;

    .profile-menu-trigger {
      display: flex;
      border: none;
      background: none;
      margin: 0;
      padding: 0;
      opacity: 0.8;

      &:hover {
          opacity: 1;
        }
    }

    .profile-menu {
      padding: 32px;
      border-radius: 12px;
      border-top-right-radius: 0px;
      border: solid 1px #403f4f;
      background-color: #2b2a3c;
      display: none;
      flex-direction: column;
      height: auto;
      width: auto;
      min-width: 200px;
      position: absolute;
      z-index: 999;
      right: 0px;
      top: 42px;
      a,
      button {
        color: ${COLOR_WHITE};
        opacity: 0.8;
        text-align: left;
        background: none;
        border: none;
        margin: 0;
        padding: 0;
        font-size: 18px;
        font-weight: normal;
        margin-right: 32px;
        &:last-child {
          margin-right: 0px;
        }
        &:hover {
          text-decoration: none;
          color: ${COLOR_WHITE};
          opacity: 1;
        }
        &.active {
          color: ${COLOR_WHITE};
          opacity: 1;
          font-weight: 600;
        }
      }
      a {
        margin: 5px 0;
      }
      &.active {
        display: flex;
      }
    }

    .user-icon {
      height: 20px;
    }

    .log-out-button {
      border: none;
      margin-top: 2px;
      margin-left: 15px;
      font-size: 14px !important;
      padding: 0px;
      border-bottom: 1px solid #f7931e;
      &.mobile {
        margin-right: 15px;
        margin-left: 0;
      }

      &:hover {
        border-bottom: none;
      }
      &:focus,
      &:active {
        box-shadow: none;
        outline: none;
      }
    }

    .special-colored {
      margin-right: 10px;
      font-size: 16px;
      font-weight: 600;
      background: -webkit-linear-gradient(180deg, #fab535, #f7931e);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .investor-counts {
      display: flex;
      flex-direction: row;
      text-align: right;
      align-items: flex-end;
      margin-right: 32px;

      &:hover {
        .dark-grey {
        color: ${COLOR_WHITE};
        }
      }

      .count {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        text-align: right;
        padding: 0 24px;
        align-items: flex-end;
        border-right: 1px solid ${rgba(COLOR_WHITE, 0.1)};

        word-break: none;
        white-space: nowrap;

        p {
          line-height: 1.25;
        }
        &:first-child {
          /* border-left: 1px solid ${rgba(COLOR_WHITE, 0.1)}; */
          /*  border-right: none; */
          border-right: 1px solid ${rgba(COLOR_WHITE, 0.1)};
          /*   padding-right: 0px; */
          padding-right: 24px;
        }

        background: none;
        border: none;
      }
    }
    .mobile-menu-trigger {
      padding: 10px 0px 10px 0px;
      margin: 0 0 0 10px;
      display: flex;
      align-items: center;
      background: none;
      border: none;
      svg {
        min-width: 32px;
        max-height: 22px;
      }
    }
  }

  @media (max-width: ${BP_TABLET_MAX}px) {
    justify-content: space-between;
    padding: 0 26px;
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    height: 48px;
    padding: 0 16px;
    .logo-wrap {
      min-width: auto;
    }
    .user-wrap {
      max-width: calc(100% - 40px);
      width: calc(100% - 40px);
      min-width: calc(100% - 40px);
      .investor-counts {
        margin-right: 0px;
        padding-right: 15px;
        display: flex;
        flex-direction: column;
        text-align: right;
        align-items: flex-start;

        .count {
          display: flex;
          flex-direction: row;
          flex-wrap: none;
          text-align: right;
          justify-content: space-between;
          width: 100%;
          padding: 0 24px 0 0px;
          align-items: center;
          border-right: 1px solid ${rgba(COLOR_WHITE, 0.1)};
          small {
            padding-right: 20px;
            font-size: 12px;
          }
          p {
            line-height: 1.25;
            font-size: 14px;
          }
          &:first-child {
            border-right: 1px solid ${rgba(COLOR_WHITE, 0.1)};
            border-left: none;
            padding-right: 0px;
            padding: 0 24px 0 0px;
          }
        }
      }

      .mobile-menu-trigger {
        margin: 0 0 0 5px;
      }
    }
  }
`;

export const UserTypeMarkSC = styled.div`
  background: ${rgba(COLOR_ORANGE, 0.2)};
  float: left;
  margin-top: 8px;
  padding: 0 15px;
  border-radius: 5px;
  display: block;
  text-align: center;

  span {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: ${COLOR_ORANGE};
  }

  &.investor {
    background: ${rgba(COLOR_BLUE, 0.2)};
    span {
      color: ${COLOR_BLUE};
    }
  }
`;
